import { get } from 'js-cookie';
import Vue from 'vue';

export function getUserId() {
    return get('ud') || get('userId') || '';
}

export function getDid() {
    return get('did') || '';
}

export function handleSuccessMessageToast(msg: string) {
    Vue.prototype.$message({
        type: 'success',
        message: msg,
        customClass: 'message-custom message-success-custom',
        iconClass: 'message-success-custom-icon',
    });
}

export function handleWarningMessageToast(msg: string) {
    Vue.prototype.$message({
        type: 'warning',
        message: msg,
        customClass: 'message-custom message-warning-custom',
        iconClass: 'message-warning-custom-icon',
    });
}

export function handleErrorMessageToast(msg: string) {
    Vue.prototype.$message({
        type: 'error',
        message: msg,
        customClass: 'message-custom message-error-custom',
        iconClass: 'message-error-custom-icon',
    });
}

export function bytesToSize(bytes: number) {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) {
        return '0 Byte';
    }
    const i = Number.parseInt(
        Math.floor(Math.log(bytes) / Math.log(1024)).toString(),
        10,
    );
    return (bytes / Math.pow(1024, i)).toFixed(1) + sizes[i];
}

export function appendSearchParamsToUrl(
    url = window.location.href,
    params: any,
) {
    const urlInstance = new URL(url);
    Object.keys(params).forEach(function (key) {
        urlInstance.searchParams.delete(key);
        urlInstance.searchParams.append(key, params[key]);
    });
    return urlInstance.toString();
}

// 防抖
// 设置防抖，保证无论拖动窗口大小，只执行一次获取浏览器宽高的方法
export function debounce (fun: { (): void; (): void; }, delay: number | undefined) {
    let timer: number | undefined;
    return function () {
        if (timer) {
            clearTimeout(timer);
        }
        timer = window.setTimeout(() => {
            fun();
        }, delay);
    }
};

// 16进制颜色转rgba
export function hexToRgba(hexColor: string, alpha = .5) {

    // 移除 # 号并提取颜色值
    const hex = hexColor.replace('#', '');

    // 将颜色值拆分成 R、G、B 三个部分
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // 转换为 RGBA 格式并添加透明度
    const rgba = `rgba(${r}, ${g}, ${b}, ${alpha})`

    return rgba;
}

/**
     * 千位逗号分隔 1999855 - 1,999,855
     * isDec 是否保留小数 例如1999855.11- 1,999,855.11;1000.00-1,000.00
 */
export function toThousands(num: number | string, isDec: boolean = false) {
    if(!num) return 0;
    if(isDec) {
        const strArr = String(num).split('.');
        const strInt = strArr[0]!.match(/^\d+/g)?.[0] ?? '';
        const strDec = strArr.length > 1 ? '.' + strArr[1] : '';
        return `${strInt.replace(/(?=(?!^)(\d{3})+$)/g, ',')}${strDec}`;
    }
    const str = String(num).match(/^\d+/g)?.[0] ?? '';
    return str.replace(/(?=(?!^)(\d{3})+$)/g, ',');
}

// V2 版本的消息提示
export function handleSuccessMessageToastV2(msg: string) {
    Vue.prototype.$ksMessage({
        type: 'success',
        message: msg
    });
}

export function handleWarningMessageToastV2(msg: string) {
    Vue.prototype.$ksMessage({
        type: 'warning',
        message: msg
    });
}

export function handleErrorMessageToastV2(msg: string) {
    Vue.prototype.$ksMessage({
        type: 'error',
        message: msg
    });
}